import { createTheme } from '@mui/material';

export const THEME = createTheme({
  typography: {
    fontFamily: 'Manrope',
    fontSize: 14,
  },
});
